export default function VentesGerant() {
  return <div style={{ padding: 40 }}>⏳ Ventes Gérant — En construction</div>;
}